import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Group from '../models/Group';

const initialState = {
    onSubmitting: false,
    isFetching: false,
    isSubmit: false,
    isFetchingUpdate: false,
    isGetItem: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
    dataUpdate: new Group()
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GROUP_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.PROPERTY_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.GROUP_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.GROUP_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.GROUP_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.GROUP_CLONE_ACTION:
            return { ...state, isFetching: true }
        case Types.GROUP_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true, isGetItem: true };
        case Types.GROUP_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.groups, isSubmit: false };
        case Types.GROUP_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate, isSubmit: false, isGetItem: false };
        case Types.GROUP_LIST_ALL_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.GROUP_LIST_ALL_SUCCESS:
            return { ...state, isFetchingUpdate: false, allGroups: action.allGroups, isSubmit: false };
        case Types.GROUP_EXPORT_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataEx: action.exGroup };
        case Types.GROUP_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.GROUP_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.GROUP_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.GROUP_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.GROUP_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.GROUP_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.GROUP_EXPORT_PRODUCT_FEED_ACTION:
            return { ...state, isFetching: true };
        case Types.GROUP_EXPORT_PRODUCT_FEED_SUCCESS:
            return { ...state, isFetching: false };
        case Types.GROUP_REINDEX_PRODUCT_ACTION:
            return { ...state, isFetching: true };
        case Types.GROUP_REINDEX_PRODUCT_SUCCESS:
            return { ...state, isFetching: false };
        case Types.GROUP_RESET:
            state = initialState;
            return { isFetching: false };
        case Types.GROUP_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isSubmit: false, isGetItem: false };
        default:
            return state;
    }
}
